import React, { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { RoleName } from '@marageti/z4-sdk/lib/auth';
import SubNavigation from '../../components/sub-navigation';
import { TabItem } from '../../components/sub-navigation/types';
import { useAuthStore } from '../../store';

const SETTINGS_LINKS: TabItem[] = [
  {
    label: 'my profile',
    to: '',
  },
  {
    label: 'country defaults',
    to: 'country-defaults',
  },
  {
    label: 'destinations',
    to: 'destinations',
  },
  {
    label: 'users',
    to: 'users',
  },
  {
    to: 'templates',
  },
];

const View = () => {
  const { loggedInTeamMember } = useAuthStore();

  const tabs = useMemo(() => {
    const isAdmin = loggedInTeamMember?.userInfo?.some((info) => info.roles?.includes(RoleName.ADMIN)) || false;
    const links = [...SETTINGS_LINKS];

    if (isAdmin) {
      links.push({
        label: 'audit',
        to: 'audit',
      });
    }

    return links;
  }, [loggedInTeamMember]);

  return (
    <>
      <SubNavigation
        profile={{
          primary: 'Settings',
          primaryTypographyProps: {
            variant: 'h3',
          },
        }}
        tabs={tabs}
      />
      <Outlet />
    </>
  );
};

export default View;
